import { connect } from 'react-redux';
import { getProductData } from 'Favourites/store/actions';

import {
    selectProducts,
    selectProduct,
} from 'Favourites/store/reducers/data/products';

import { LIST_TYPE } from 'Favourites/store/constants';

const mapStateToProps = (state, ownProps) => {
    let data;
    if (ownProps.data) {
        data = ownProps.data;
    } else if (selectProducts(state)) {
        data = selectProduct(state, ownProps.productId);
    } else {
        data = false;
    }

    return { data };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProductData: (id, type, quantity) => {
            dispatch(getProductData(id, type, quantity, LIST_TYPE));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps);
